// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"61":"9dc51d6d1a5cde11","665":"cd4bf97f005b5ddf"}[chunkId] + ".js";
};